import { Button, DrawerFooter, useToast, VStack } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import {
  createKeyword,
  createKeywordDealership,
} from "../../../utils/api/global-config.api";
import { Drawer, Input } from "../../common";

type data = {
  isOpen: boolean;
  onClose: any;
  refetchParent: any;
};
interface ApiResult {
  data: any;
}
interface ApiRequest {
  keyword: {
    name: string;
  };
}
const CreateKeyword = (props: data) => {
  const { isOpen, onClose, refetchParent } = props;
  const toast = useToast();
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const { id: dId } = useParams();
  const mutation = useMutation(createKeyword);
  const mutationDealership = useMutation(createKeywordDealership);

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!name?.trim()) {
      setNameError("Keyword cannot be empty");
      return;
    }

    setNameError("");
    const mutationFunc = dId ? mutationDealership : mutation;

    mutationFunc.mutate(
      {
        dId,
        payload: {
          keyword: {
            name: name,
          },
        },
      },
      {
        onSuccess: () => {
          refetchParent();
          onClose();
          toast({
            description: "Keyword created successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top",
          });
        },
        onError: (error: any) => {
          toast({
            description: `Error creating keyword: ${
              error?.response?.data?.errors?.toString() ??
              "Something went wrong"
            }`,
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top",
          });
        },
      }
    );
  };

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title="Create Keyword"
      isLoading={mutation?.isLoading}
    >
      <VStack alignItems="flex-start" padding="1rem 1.5rem" w="100%" gap="1rem">
        <Input
          placeholder="Write Keyword"
          label="Enter Keyword"
          onChange={(e: any) => setName(e.target.value)}
          value={name}
          isRequired={true}
          error={nameError}
        />
      </VStack>
      <DrawerFooter
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        borderTop="1px solid var(--grey-300)"
        display="flex"
        alignItems="center"
        gap="0.81rem"
      >
        <Button variant="outline" w="100%" size="xl" onClick={onClose}>
          Cancel
        </Button>
        <Button w="100%" size="xl" onClick={handleSubmit}>
          Confirm
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default CreateKeyword;
